import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Modal, Row, Col, Button, Container } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import TextLoading from "../../global/TextLoading";
import { components } from "react-select";

import { GetStudentsForClass, AddStudentsClass } from "../../../api/class";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <span
        className="bi bi-search"
        aria-hidden="true"
        style={{ color: "#000", marginRight: "5px" }}
      />
    </components.DropdownIndicator>
  );
};
export default function ModalAddStudents(props) {
  const [t] = useTranslation(["class", "global"]);
  const [studentsFound, setStudentsFound] = useState(null);
  const [preselectedStudents, setPreselectedStudents] = useState([]);
  const [saving, setSaving] = useState(false);

  let [typingCallback, setTypingCallback] = useState(null);

  useEffect(() => {
    // Initial load
    searchStudents("", (studentsFormat) => {
      setStudentsFound(studentsFormat);
    });
  }, []);

  /**
   *gets students by text search
   * @param {String} inputValue
   * @param {function} callback
   */
  const searchStudents = (inputValue, callback) => {
    if (typingCallback) {
      clearTimeout(typingCallback);
    }
    typingCallback = setTimeout(() => {
      let payload = props.filters;
      payload.limit = 50;
      if (inputValue != "") payload.search = inputValue;

      GetStudentsForClass(payload).then((result) => {
        const data = result.data.filter(
          (student) => student.status == "Activo" || student.status == "Active",
        );
        const scolarship = (student) => {
          let level = "";
          if (student.grade_level) {
            level = ` - ${student.grade_level} ` + student.group_name;
          } else {
            level = ` - ` + t("class:stundentsClass.higherLevel");
          }
          return level;
        };

        const studentsFormat = data.map((item) => {
          return {
            id: item.id,
            value: item.id,
            label:
              `${item.first_name} ${item.middle_name} ${item.last_name}` +
              scolarship(item),
            name:
              `${item.first_name} ${item.middle_name} ${item.last_name}` +
              scolarship(item),
          };
        });
        // filtrar, dejar solo los que no estan en props.classStudents
        let filteredStudents = studentsFormat.filter((student) => {
          return !props.classStudents.some(
            (classStudent) => classStudent.id === student.value,
          );
        });
        // filtrar, dejar solo los que no estan en preselectedStudents
        filteredStudents = filteredStudents.filter((student) => {
          return !preselectedStudents.some(
            (preselectedStudent) => preselectedStudent.value === student.value,
          );
        });
        // si hay mas de un estudiante, añadir opcion de todos
        if (filteredStudents.length > 1) {
          filteredStudents.unshift({
            id: 0,
            value: 0,
            label: t("class:modalAddStudentsClass.selectAll"),
          });
        }
        callback(filteredStudents);
      });
    }, 1000);
    setTypingCallback(typingCallback);
  };

  const confirmSelection = () => {
    // identificar si es edicion o nueva clase
    if (props.classId !== "new") {
      addStudentsToClass();
    } else {
      // si es nueva clase
      props.addStudents(preselectedStudents);
      props.setShowModalAddStudents(false);
    }
  };

  const addStudentsToClass = () => {
    setSaving(true);
    let studentsIds = preselectedStudents.map((student) => student.value);
    const payload = {
      student_ids: studentsIds,
      class_id: props.classId,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    AddStudentsClass(payload).then(() => {
      props.setShowModalAddStudents(false);
      props.setRefreshStudentList(true);
      setSaving(false);
    });
  };

  return (
    <Modal show={props.showModalAddStudents} id="modalAddStudents">
      <Modal.Header className="modal-header">
        <Modal.Title className="modal-title text-center">
          {t("class:modalAddStudentsClass.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body mbottom10">
        <Container>
          <Row>
            <Col md={12} className="px-0 pb-2">
              {t("class:modalAddStudentsClass.selectStudentTheList")}
            </Col>
            <Col md={12} className="px-0">
              <AsyncSelect
                id="selectStudentToAdd"
                loadOptions={searchStudents}
                placeholder={t("class:main.searchStudent")}
                onChange={(student) => {
                  if (student == null) return;
                  let students = [...preselectedStudents];
                  // si selecciona todos
                  if (student.value === 0) {
                    students = students.concat(
                      (studentsFound || []).filter((s) => s.value !== 0),
                    );
                    setPreselectedStudents(students);
                    return;
                  } else {
                    students.push(student);
                  }
                  setPreselectedStudents(students);
                }}
                isClearable
                defaultOptions={
                  studentsFound
                    ? studentsFound.filter((student) => {
                        return !preselectedStudents.some(
                          (preselectedStudent) =>
                            preselectedStudent.value === student.value,
                        );
                      })
                    : false
                }
                loadingMessage={() => t("global:select.searching")}
                noOptionsMessage={() => t("global:select.noMatches")}
                value={null}
                components={{
                  DropdownIndicator,
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col
              md={12}
              style={{
                textAlign: "justify",
                marginTop: 10,
                border: "1px solid #ddd",
                padding: 10,
              }}
            >
              <b>{t("class:modalAddStudentsClass.nameStudent")}</b>
            </Col>
          </Row>
          {preselectedStudents.map((student, index) => (
            <Row key={index}>
              <Col
                md={12}
                style={{
                  textAlign: "justify",
                  marginTop: -1,
                  border: "1px solid #ddd",
                  padding: 10,
                }}
              >
                {student.label}
                <Button
                  id={"remove-" + index}
                  variant="outline-danger"
                  className="float-end "
                  onClick={() => {
                    let students = [...preselectedStudents];
                    students.splice(index, 1);
                    setPreselectedStudents(students);
                  }}
                >
                  {t("class:modalAddStudentsClass.removeStudent")}
                </Button>
              </Col>
            </Row>
          ))}
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button
            id="btnCancelAddStudents"
            variant="outline-secondary"
            onClick={() => props.setShowModalAddStudents(false)}
          >
            {t("global:buttons.cancel")}
          </Button>
          <Button
            id="btnAcceptModalAddStudents"
            variant="primary"
            onClick={() => confirmSelection()}
            disabled={preselectedStudents.length === 0 || saving}
          >
            {saving ? (
              <TextLoading text={t("global:buttons.saving")} variant="light" />
            ) : (
              t("class:modalAddStudentsClass.addStudents")
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

ModalAddStudents.propTypes = {
  classId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showModalAddStudents: PropTypes.bool.isRequired,
  setShowModalAddStudents: PropTypes.func.isRequired,
  filters: PropTypes.object,
  classStudents: PropTypes.array,
  addStudents: PropTypes.func,
  setRefreshStudentList: PropTypes.func,
};
